<script setup lang="ts">
import { ref } from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { Locale } from 'ant-design-vue/lib/locale-provider'
import FileUpload from './components/file-upload/file-upload.vue'
import { loadingPinia } from './store/loading'
const locale = ref<Locale>(zhCN)
const loadingObj = loadingPinia()
</script>

<template>
  <a-spin :spinning="loadingObj.loading" wrapperClassName="global-spin" tip="加载中..." @click.stop>
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
    <!-- 弹框容器 -->
    <div id="modal-container" @click.stop></div>
    <!-- 抽屉容器 -->
    <div id="drawer-container" @click.stop></div>
    <!-- 全屏 -->
    <div id="full-container"></div>
  </a-spin>
  <FileUpload />
</template>
